const footerItems = [
  {
    title: "Learn About OEE",
    categories: [
      {
        items: [
          {
            text: "What is OEE?",
            url: "/",
          },
          {
            text: "OEE Factors",
            url: "/oee-factors/",
          },
          {
            text: "Six Big Losses",
            url: "/oee-six-big-losses/",
          },
          {
            text: "Hidden Factory",
            url: "/hidden-factory/",
          },
          {
            text: "Practical OEE",
            url: "/practical-oee/",
          },
        ],
      },
      {
        items: [
          {
            text: "Calculate OEE",
            url: "/calculating-oee/",
          },
          {
            text: "Implement OEE",
            url: "/implementing-oee/",
          },
          {
            text: "Calculate TEEP",
            url: "/teep/",
          },
          {
            text: "Visual OEE ™",
            url: "/visual-oee/",
          },
        ],
      },
      {
        items: [
          {
            text: "Improve OEE",
            url: "/improve-oee/",
          },
          {
            text: "World-Class",
            url: "/world-class-oee/",
          },
          {
            text: "Address the Six Big Losses",
            url: "/oee-six-big-losses/",
          },
          {
            text: "Takt Time",
            url: "/takt-time/",
          },
        ],
      },
    ],
  },
  {
    title: "Resources",
    categories: [
      {
        items: [
          {
            text: "Free OEE Tools",
            url: "/free-oee-tools/",
          },
          {
            text: "OEE Glossary",
            url: "/oee-glossary/",
          },
          {
            text: "FAQ",
            url: "/faq/",
          },
        ],
      },
    ],
  },
  {
    title: "About Us",
    categories: [
      {
        items: [
          {
            text: "Our Company",
            url: "https://www.vorne.com/about-us/about/",
          },
          {
            text: "Vorne.com",
            url: "https://www.vorne.com",
          },
          {
            text: "LeanProduction.com",
            url: "https://www.leanproduction.com",
          },
          {
            text: "Vorne XL Free Trial	",
            url: "https://www.vorne.com/products/free-trial/",
          },
        ],
      },
    ],
  },
];

export default footerItems;
